module.exports = __webpack_public_path__ + "static/img/moren-tupian.2bf3d2e6.png";